export const NAME = 'toolbar';

export const INIT_TOOLBAR_REQUEST = 'INIT_TOOLBAR_REQUEST';
export const INIT_TOOLBAR_SUCCESS = 'INIT_TOOLBAR_SUCCESS';
export const INIT_TOOLBAR_FAILURE = 'INIT_TOOLBAR_FAILURE';

export const URL_CHROME =
    'https://chromewebstore.google.com/detail/l%E2%80%99extension-cashback-floa/kmfgpbjcaigfilcmdlndbcjadobcfebd?hl=fr&pli=1';
export const URL_FIREFOX = 'https://addons.mozilla.org/fr/firefox/addon/l-extension-cashback-floa/';
export const URL_EDGE = 'https://chromewebstore.google.com/detail/l%E2%80%99extension-cashback-floa/kmfgpbjcaigfilcmdlndbcjadobcfebd?hl=fr&pli=1';
export const URL_SAFARI = '';



// WEBPACK FOOTER //
// ./src/services/toolbar/constants.js